import React from "react";
import PropTypes from "prop-types";
import { displayModal } from "actions/shared-actions";
import { connect } from "react-redux";
import ProductDrawerHelper from "helpers/product-drawer-helper";
import RtrImage from "../shared/rtr-image";

function PDPImageryFeaturedPhotoReview(props) {
  const handleClick = () => {
    const { displayReviewPhotosModal } = props;
    displayReviewPhotosModal();
  };

  const reviews = props.reviews || {};
  const reviewsWithPhotos = ProductDrawerHelper.getOnlyReviewsWithPhotos(reviews);
  const coverPhoto = props.reviewsCoverPhotos?.[0] || reviewsWithPhotos?.[0]?.moment?.photos?.[0];

  if (!coverPhoto) {
    return null;
  }

  const thumbnailUrl = coverPhoto.hasCroppedPhoto ? coverPhoto.urls.imageCroppedThumb : coverPhoto.urls.imageThumb;
  const imageCropperClass = "image-cropper" + (props.isProductDrawer ? " image-cropper--drawer" : "");

  return (
    <div className="moment-images-wrapper">
      <div className="pdp-imagery-moments-wrapper">
        <a
          className="pdp-imagery-moments"
          data-lightbox-source="alt-cust-image"
          data-photoid={coverPhoto.id}
          href="#reviews-partial"
          onClick={handleClick}>
          <div className={imageCropperClass}>
            <RtrImage alt="" src={thumbnailUrl} />
          </div>
          {reviewsWithPhotos.length && (
            <p className="universal-small">
              Customer Photos <span className="count">{"(" + reviewsWithPhotos.length + ")"}</span>
            </p>
          )}
        </a>
      </div>
    </div>
  );
}

PDPImageryFeaturedPhotoReview.propTypes = {
  displayReviewPhotosModal: PropTypes.func,
  isProductDrawer: PropTypes.bool,
  reviews: PropTypes.shape({
    summary: PropTypes.object,
  }),
  reviewsCoverPhotos: PropTypes.array,
};

const mapDispatchToProps = dispatch => {
  return {
    displayReviewPhotosModal: () => {
      dispatch(displayModal("REVIEW_PHOTOS"));
    },
  };
};

export default connect(null, mapDispatchToProps)(PDPImageryFeaturedPhotoReview);
